import Axios from '../utils/Axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';
import { SelectType } from '../components/DropdownSelect';

export type NotificationType = {
  notice_id: number;
  title: string;
  created_at: string;
  wasRead: number;
  content: string;
};

const NoticeController = {
  getlist: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/notice/getlist`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[공지사항 리스트 조회 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getdetail: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/notice/getdetail';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[공지사항 내용 조회 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getUnreadCount: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/notice/getUnreadCount`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[공지사항 안 읽은 항목 수 조회 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default NoticeController;
